import React from 'react';
import Icon from '../../../components/AppIcon';

const SidebarNavigation = ({ activeSection, onSectionChange }) => {
  const navigationSections = [
    {
      id: 'terms',
      title: 'Terms of Service',
      icon: 'Scale',
      subsections: [
        { id: 'acceptance', title: 'Acceptance of Terms' },
        { id: 'service-description', title: 'Service Description' },
        { id: 'user-accounts', title: 'User Accounts' },
        { id: 'acceptable-use', title: 'Acceptable Use Policy' },
        { id: 'payment-terms', title: 'Payment Terms' },
        { id: 'intellectual-property', title: 'Intellectual Property' },
        { id: 'data-protection', title: 'Data Protection' },
        { id: 'service-availability', title: 'Service Availability' },
        { id: 'limitation-liability', title: 'Limitation of Liability' },
        { id: 'termination', title: 'Termination' },
        { id: 'governing-law', title: 'Governing Law' },
        { id: 'changes-terms', title: 'Changes to Terms' }
      ]
    },
    {
      id: 'privacy',
      title: 'Privacy Policy',
      icon: 'Shield',
      subsections: [
        { id: 'information-collection', title: 'Information We Collect' },
        { id: 'information-use', title: 'How We Use Information' },
        { id: 'data-sharing', title: 'Data Sharing & Disclosure' },
        { id: 'data-security', title: 'Data Security' },
        { id: 'user-rights', title: 'Your Rights & Choices' },
        { id: 'cookies', title: 'Cookie Policy' },
        { id: 'international-transfers', title: 'International Transfers' },
        { id: 'policy-changes', title: 'Changes to Policy' }
      ]
    }
  ];

  const handleSubsectionClick = (sectionId, subsectionId) => {
    onSectionChange(sectionId);
    // Add smooth scroll to subsection after a brief delay for section to load
    setTimeout(() => {
      const element = document.getElementById(subsectionId);
      if (element) {
        element?.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start',
          inline: 'nearest' 
        });
      }
    }, 100);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <Icon name="FileText" size={20} className="mr-2 text-blue-600" />
        Legal Documents
      </h3>
      <nav className="space-y-4">
        {navigationSections?.map((section) => (
          <div key={section?.id} className="space-y-2">
            
            {/* Main Section Header */}
            <button
              onClick={() => onSectionChange(section?.id)}
              className={`w-full flex items-center justify-between p-3 rounded-lg text-left transition-all ${
                activeSection === section?.id
                  ? 'bg-blue-100 text-blue-900 border border-blue-200' :'text-gray-700 hover:bg-gray-50 border border-transparent'
              }`}
            >
              <div className="flex items-center">
                <Icon 
                  name={section?.icon} 
                  size={18} 
                  className={`mr-3 ${
                    activeSection === section?.id ? 'text-blue-600' : 'text-gray-500'
                  }`} 
                />
                <span className="font-medium">{section?.title}</span>
              </div>
              
              <Icon 
                name={activeSection === section?.id ? 'ChevronDown' : 'ChevronRight'} 
                size={16} 
                className={activeSection === section?.id ? 'text-blue-600' : 'text-gray-400'} 
              />
            </button>

            {/* Subsection Jump Links */}
            {activeSection === section?.id && section?.subsections && (
              <div className="ml-4 space-y-1 border-l-2 border-blue-100 pl-4">
                {section?.subsections?.map((subsection) => (
                  <button
                    key={subsection?.id}
                    onClick={() => handleSubsectionClick(section?.id, subsection?.id)}
                    className="block w-full text-left text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 py-1.5 px-2 rounded transition-colors"
                  >
                    {subsection?.title}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
      {/* Quick Actions */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-sm font-semibold text-gray-700 mb-3">Quick Actions</h4>
        <div className="space-y-2">
          <button
            onClick={() => window.print()}
            className="w-full flex items-center text-sm text-gray-600 hover:text-gray-900 py-1.5 px-2 rounded hover:bg-gray-50 transition-colors"
          >
            <Icon name="Printer" size={14} className="mr-2" />
            Print Document
          </button>
          
          <button
            onClick={() => {
              const url = window.location?.href;
              navigator.clipboard?.writeText(url);
            }}
            className="w-full flex items-center text-sm text-gray-600 hover:text-gray-900 py-1.5 px-2 rounded hover:bg-gray-50 transition-colors"
          >
            <Icon name="Share" size={14} className="mr-2" />
            Share Link
          </button>
          
          <a
            href="mailto:legal@intime.com?subject=Legal Document Question"
            className="w-full flex items-center text-sm text-gray-600 hover:text-gray-900 py-1.5 px-2 rounded hover:bg-gray-50 transition-colors"
          >
            <Icon name="Mail" size={14} className="mr-2" />
            Contact Legal Team
          </a>
        </div>
      </div>
      {/* Version Information */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="text-xs text-gray-500 space-y-1">
          <p className="flex items-center">
            <Icon name="Calendar" size={12} className="mr-1" />
            Last updated: Dec 17, 2024
          </p>
          <p className="flex items-center">
            <Icon name="Hash" size={12} className="mr-1" />
            Version: 2.1
          </p>
        </div>
      </div>
    </div>
  );
};

export default SidebarNavigation;